import { Catch } from '../common/catch';
import { ICESReleases } from '../ices/ices-releases';
import { ICESGroup } from '../interfaces/ices-group';

export class ICESCatchGroup implements ICESGroup {
    public Total: number;
    constructor (
        public ICES: string,
        public Catches: Catch[] = [],
        public Recaptures: ICESReleases = null
    ){
        this.Total = 0;
    }
}